<div *ngIf="isApiCalling" class="d-flex justify-content-center align-items-center card"
    style="width: 100%; height: 50vh">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div *ngIf="profileInfo && !isApiCalling" class="card">
    <div class="card-body p-4">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center w-100 justify-content-start" style="gap: 0.5rem;">
                <div class="position-relative">
                    <img [src]="profileInfo.Picture" alt="Google Profile" class="rounded-circle border"
                        style="width: 54px; height: 54px; object-fit: cover;" referrerpolicy="no-referrer">

                    <div class="position-absolute bg-success border border-white rounded-circle"
                        style="width: 13px; height: 13px; top: 0px; right: 0px;" title="Linked">
                    </div>
                </div>
                <div class="d-flex flex-column" style="max-width: 90%;">
                    <h6 class="mb-0 fw-bold text-dark text-truncate" style="max-width: 90%;">
                        {{ profileInfo.Name }}
                    </h6>
                    <p class="text-muted small mb-0 text-truncate" style="max-width: 90%;">
                        {{ profileInfo.Email }}
                    </p>
                </div>
            </div>
        </div>
        <div class="text-end mt-2 d-flex w-100 justify-content-center">
            <button class="btn btn-outline-danger btn-sm px-3 w-100" (click)="deleteAccount()">
                <i class="bi bi-trash3 me-1"></i> Remove
            </button>
        </div>

        <hr class="my-3 opacity-10">

        <div class="d-flex align-items-center text-muted small" style="gap: 0.5rem;">
            <i class="bi bi-shield-check me-2 text-primary"></i>
            <span>
                Connected to <strong>Google Drive</strong>.
                Access is limited to files created by this application only.
            </span>
        </div>
    </div>
</div>

<div class="card border border-dashed p-5 text-center" *ngIf="!profileInfo && !isApiCalling">
    <div class="mb-3">
        <i class="bi bi-google text-muted" style="font-size: 2rem;"></i>
    </div>
    <h5>No Google Account Linked</h5>
    <p class="text-muted small">Link your Google Drive to automatically archive your purchase and sale deeds.</p>
    <button *ngIf="pollingCountDown == 0" class="btn btn-primary px-4" (click)="redirectToAuthDomain()">
        Click to Link
    </button>
    <div *ngIf="pollingCountDown > 0"
        class="d-flex flex-column align-items-center justify-content-center rounded border border-secondary bg-light"
        style="width: 100%; height: 100%; z-index: 10; border-style: dashed !important;">
        <div class="d-flex justify-content-center">
            Checking connection...
            <div class="spinner-border m-auto mb-3" role="status" style="width:1rem; height: 1rem;">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        {{ pollingCountDown }}s remaining
        <small class="text-muted">Please do not refresh or close this page</small>
    </div>
</div>

<div class="d-flex flex-column px-3 py-2 mt-3 mx-2" *ngIf="!isHistoryLoading">
    <h5 class="fw-bold text-xl mb-3">
        Connection History
    </h5>
    <div class="text-center py-5" *ngIf="authHistory.length === 0">
        <i class="pi pi-info-circle text-muted mb-2" style="font-size: 1.5rem;"></i>
        <p class="text-muted">No connection history found.</p>
    </div>
    <div class="card mb-3 border-0 shadow-sm" *ngFor="let history of authHistory" style="border-radius: 10px;">
        <div class="card-body p-3">
            <div class="d-flex align-items-center mb-3">
                <div class="bg-light rounded-circle d-flex align-items-center justify-content-center mr-3"
                    style="width: 36px; height: 36px; flex-shrink: 0;">
                    <i class="bi bi-google" style="color: #4285F4; font-size: 1rem;"></i>
                </div>
                <div class="overflow-hidden">
                    <small class="text-muted d-block text-uppercase font-weight-bold"
                        style="font-size: 10px; letter-spacing: 0.5px;">
                        Account Email
                    </small>
                    <div class="fw-medium text-truncate" style="color:#444050; font-size: 14px;">
                        {{ history.email }}
                    </div>
                </div>
            </div>

            <div class="row no-gutters bg-light rounded p-2">
                <div class="col-6 pr-2 border-right">
                    <small class="d-block text-muted mb-1" style="font-size: 10px;">Added Date</small>
                    <span class="d-block font-weight-bold text-dark" style="font-size: 12px;">
                        {{ (history.linkedOn | date:'mediumDate') || 'N/A' }}
                    </span>
                </div>
                <div class="col-6 pl-3">
                    <small class="d-block text-muted mb-1" style="font-size: 10px;">Removed Date</small>
                    <span class="d-block font-weight-bold" [ngClass]="history.unlinkedOn ? 'text-danger' : 'text-muted'"
                        style="font-size: 12px;">
                        {{ (history.unlinkedOn | date:'mediumDate') || 'Active' }}
                    </span>
                </div>
            </div>

        </div>
    </div>
</div>

<app-dialog-popup *ngIf="showDeletionConfirmationAlert && !isApiCalling" [isConfirmation]="true"
    (close)="handleCancel()" (reject)="handleCancel()" (accept)="handleConfirm()">
    Are you sure you want to remove your account? Previously stored data will not be available if you use a new account.
</app-dialog-popup>